import React from 'react';
import { fontFamily } from '../theme/tokens';
import { BANNER_IMAGES } from '../config/imagePaths';
import { useIsMobile } from '../hooks/useMediaQuery';
import PublicHeader from './layout/PublicHeader';
import AnnouncementTicker from './layout/AnnouncementTicker';

// Public splash page shown at "/" to logged-out visitors.
const LandingPage = () => {
  const isMobile = useIsMobile();

  return (
    <div style={{ width: '100%', fontFamily }}>
      <AnnouncementTicker />
      <PublicHeader />

      <main
        style={{
          background: '#ffebcb', overflow: 'hidden', position: 'relative',
          // On phones, size the banner to the illustration so the whole image is visible
          ...(isMobile ? { aspectRatio: '775 / 410' } : { height: '66vh', minHeight: 280 }),
        }}
      >
        {/* Source art has empty margins: crop to the illustration (x 25-800, y 95-505 of 822x596) */}
        <div
          style={{
            position: 'absolute', top: 0, left: '50%', height: '100%', aspectRatio: '775 / 410',
            transform: 'translateX(-50%)', overflow: 'hidden',
          }}
        >
          <img
            src={BANNER_IMAGES.SPLASH}
            alt="Order your school books online and get them delivered to your door"
            style={{
              position: 'absolute', display: 'block', maxWidth: 'none', width: (822 / 775) * 100 + '%',
              left: -(25 / 775) * 100 + '%', top: -(95 / 410) * 100 + '%', height: (596 / 410) * 100 + '%',
            }}
          />
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
